import React from 'react';
import useRootSelector from 'common/hooks/useRootSelector';
import { IntlProvider } from 'react-intl';
import { selectLocale } from 'common/state/settings/selectors';
import { IObject } from 'common/interfaces/common';

interface IProps {
  messages: IObject;
  children: React.ReactNode;
}

export const LanguageProvider: React.FC<IProps> = ({ messages, children }: IProps) => {
  const locale = useRootSelector(selectLocale);
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {React.Children.only(children)}
    </IntlProvider>
  );
};

export default LanguageProvider;
